import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ServerConfigService } from './server-config.service';

@Injectable({
  providedIn: 'root',
})
export class ServerDefaultConfigService extends ServerConfigService {
  constructor() {
    super();
    this.config = {
      onemine: {
        host: environment.serverHost,
        port: environment.serverPort,
        basePath: environment.serverBasePath,
      },
    };
    this.setDefaultConfig('onemine');
  }
}
